import React, { MouseEvent } from "react";
import {
  ListItemIcon,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemButtonBaseProps,
  ListItemTextProps,
  styled,
} from "@mui/material";
import { Link, LinkProps } from "react-router-dom";
import { isEmpty } from "lodash";

type ListLinkProps = Omit<LinkProps, "onClick"> &
  Omit<ListItemButtonBaseProps, "onClick"> & {
    isActive: boolean;
    icon?: React.ReactNode;
    showIcon?: boolean;
    label: string;
    onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  };
export const ListLink = ({
  isActive,
  icon,
  showIcon = false,
  label,
  onClick,
  ...props
}: ListLinkProps) => {
  return (
    <ListItem disablePadding>
      <ListItemButton
        component={Link}
        {...props}
        onClick={(e) => {
          if (isEmpty(props.to)) {
            e.preventDefault();
          }
          onClick?.(e);
        }}
        sx={{
          "& .MuiTypography-root": {
            transition: "color 0.2s ease-in",
          },
          "& path": {
            transition: "color 0.2s ease-in",
          },
          "& circle": {
            transition: "color 0.2s ease-in",
          },
          "&:hover": {
            "& .MuiTypography-root": {
              color: "custom.hover",
            },
            "& path": {
              color: "custom.hover",
            },
            "& circle": {
              color: "custom.hover",
            },
          },
        }}
      >
        {!showIcon && icon && (
          <ListItemIcon sx={{ color: "custom.label", "& path":{color: "custom.label"},"& circle":{color: "custom.main"} }}>{icon}</ListItemIcon>
        )}

        <StyledListItemText
          isActive={isActive}
          primary={label}
          sx={{ "& span":{color: "custom.label"} }}
        />
      </ListItemButton>
    </ListItem>
  );
};

type StyledListItemTextProps = ListItemTextProps & { isActive: boolean };
const StyledListItemText = styled(ListItemText,{
  shouldForwardProp: (prop) => prop !== "isActive"})<StyledListItemTextProps>(
  ({ isActive }) => ({
    "& span": {
      fontWeight: isActive ? "bold" : "normal",
      textDecoration: "none",
      textShadow: isActive?"#e76712 0px 0 1px":"none",
    },
  })
);
